import React, { forwardRef } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import { ZoomIn, ZoomOut, Print, Fullscreen, NavigateBefore, NavigateNext } from "@mui/icons-material";

// 🔥 Đảm bảo forwardRef được gán đúng
const ReportComponent = forwardRef(function ReportComponent({ handlePrint, zoom, setZoom, reportData }, ref) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f0f2f5",
        overflow: "hidden",
      }}
    >
      {/* Toolbar */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          mb: 2,
          backgroundColor: "#fff",
          padding: 1,
          borderRadius: 2,
          boxShadow: 2,
        }}
      >
        <IconButton onClick={() => setZoom((prev) => Math.min(prev + 0.1, 2))}>
          <ZoomIn />
        </IconButton>
        <IconButton onClick={() => setZoom((prev) => Math.max(prev - 0.1, 0.5))}>
          <ZoomOut />
        </IconButton>
        <IconButton>
          <NavigateBefore />
        </IconButton>
        <IconButton>
          <NavigateNext />
        </IconButton>
        <IconButton>
          <Fullscreen />
        </IconButton>
        <IconButton onClick={handlePrint}>
          <Print />
        </IconButton>
      </Box>

      {/* Wrapper chứa nội dung A4 */}
      <Box
        sx={{
          width: "100%",
          height: "calc(100vh - 100px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          backgroundColor: "#d3d3d3",
          borderRadius: 2,
          boxShadow: 3,
          overflow: "auto",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "inline-block",
            width: `calc(210mm * ${zoom})`,
            height: `calc(297mm * ${zoom})`,
          }}
        >
          {/* Tờ A4 */}
          <Box
            id="printable-report"
            ref={ref} // 🔥 Đảm bảo ref được gán vào đúng phần tử này!
            sx={{
              width: "210mm",
              height: "297mm",
              padding: "20px",
              background: "white",
              transform: `scale(${zoom})`,
              transformOrigin: "top left",
              transition: "transform 0.3s ease-in-out",
              overflow: "hidden",
              position: "relative",
              "@media print": {
                width: "210mm",
                height: "297mm",
                margin: "0 auto",
                boxShadow: "none",
                background: "white",
                transform: "none", // In đúng kích thước, không scale
              },
            }}
          >
            <Typography variant="h5" fontWeight="bold" align="center" gutterBottom>
              Báo Cáo Cuối Ngày Về Bán Hàng
            </Typography>
            <Typography variant="body1" align="center">Chi nhánh: Chi nhánh trung tâm</Typography>
            <Typography variant="body2" align="center" mb={2}>Ngày lập: 01/03/2025</Typography>

            <TableContainer component={Paper} sx={{ width: "100%", maxHeight: "75%", overflow: "auto" }}>
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: "#cce5ff" }}>
                    <TableCell><b>Mã giao dịch</b></TableCell>
                    <TableCell><b>Thời gian</b></TableCell>
                    <TableCell><b>SL</b></TableCell>
                    <TableCell><b>Doanh thu</b></TableCell>
                    <TableCell><b>Thực thu</b></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.transactionId}</TableCell>
                      <TableCell>{item.time}</TableCell>
                      <TableCell>{item.quantity}</TableCell>
                      <TableCell>{item.revenue.toLocaleString()} VND</TableCell>
                      <TableCell>{item.actualRevenue.toLocaleString()} VND</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

export default ReportComponent; // ✅ Xuất khẩu đúng cách
